import axios from "../Axios/Default";
import { handleResponse } from "../Utils/Utils";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const authUser = (payload, onSuccess, onError) => {
  const response = axios.post("v2/login", payload, config);
  return handleResponse(response, onSuccess, onError);
};

export const msAuthUser = (payload, onSuccess, onError) => {
  const response = axios.post("v2/mslogin", payload, config);
  return handleResponse(response, onSuccess, onError);
};
